<template>
  <div class="container full scroll" style="padding: 0; overflow-y: auto; width:480px;">
    <div class="md_tab_header" style="z-index: 100;">
      <b-nav justified class="container tab_bar">
        <b-nav-item @click="activeTab=TAB.ALL"  link-classes="tab-item" :class="{'md_active' : (activeTab==TAB.ALL)}">{{$t('map.my_site')}}</b-nav-item>
        <b-nav-item @click="activeTab=TAB.GROUP"  link-classes="tab-item">{{$t('map.group_site')}}</b-nav-item>
<!--        <b-nav-item @click="activeTab=TAB.TRANSFER" link-classes="tab-item" :class="{'md_active' : (activeTab==TAB.TRANSFER)}">{{$t('map.transfer_site')}}</b-nav-item>-->
      </b-nav>
      <b-input-group class="container mt-2 mb-2" style="width: 480px;font-family: $korean_gd_14_r;">
        <b-form-input v-model="search_name"
                      style="height: 40px; font-size: 16px; font-family: KoreanGD14R;"
                      :placeholder='$t("site_report.search_site_name_placeholder")'
                      @keydown.enter="onSearch">
        </b-form-input>
        <b-input-group-append>
          <b-button
            variant="white"
            class="transparent"
            style="height: 40px;border: 1px solid #ced4da;"
            @click="onSearch"
          >
            <b-icon icon="search" variant="primary"></b-icon>
          </b-button>
        </b-input-group-append>
        <b-button variant="white" style="position: initial;margin-left: 10px;margin-top: 2px;" class="update_all_btn update_btn_label" @click="updateAll">{{$t("common.update_all")}}</b-button>
      </b-input-group>
    </div>
    <div class="body">
      <div v-if="activeTab == TAB.GROUP" style="width: 94%;margin: auto;">
        <div class="align-vertical" style="opacity: 1; background-color: white">
          <div class="align-horizontal" style="height: 45px; position: relative">
            <b-img :src="require('../../../../assets/image/ic_link.png')" class="img_link" />
            <b-button :variant="selectedGroup ? 'primary' : 'secondary'"
                      class="flex_1 center bottom_btn_text no_border_radius" style="height: 45px;padding-top: 14px;"
                      :style="{backgroundColor : selectedGroup ? '#457fff' : '#cacbcd' }"
                      @click="onShowGroup">
              {{selectedGroup ? selectedGroup.f_name : $t('group.no_group')}}
            </b-button>
            <b-button class="flex_1 center bottom_btn_text no_border_radius"
                      style="color: #457fff; background-color: #E6F0FD; height: 45px;padding-top: 10px;" @click="onShowGroupMemberMng">
              {{$t('group.group_member_mng')}}
            </b-button>
          </div>
          <div class="align-vertical" v-if="showGroupList">
            <div class="align-vertical"
                 style="overflow-y: auto"
                 :style="{height: String(45 * Math.min(5, myGroupList.length)) + 'px'}">
              <b-button class="flex_1 center bottom_btn_text no_border_radius"
                        v-for="(item, index) in myGroupList"
                        :key="`group-${index.toString()}`"
                        style="height: 45px"
                        variant="white"
                        :style="{
                          color: (!selectedGroup || selectedGroup.f_idx != item.f_idx) ? '#457fff': 'white',
                          backgroundColor: (!selectedGroup || selectedGroup.f_idx == item.f_idx) ? '#96B7FF': 'white'
                        }"
                        @click="() => {
                        u.setState(self, {selectedGroup: item, showGroupList: false}, () => {
                          self.getSitesOfGroup(item.f_idx);
                        })}">
                {{item.f_name}}
              </b-button>
            </div>
            <div class="align-horizontal">
              <b-button v-if="myGroupList.length == 0" class="flex_1 center bottom_btn_text btn_lg" style="background-color: #0840ba" @click="onAddGroup">
                {{$t('group.create_group')}}
              </b-button>
              <div class="flex_1 align-horizontal" v-else>
                <b-button class="flex_1 center bottom_btn_text btn_lg" style="background-color: #cf0000" @click="onLeaveGroup">
                  {{$t('group.leave_group')}}
                </b-button>
                <b-button class="flex_1 center bottom_btn_text btn_lg" style="background-color: #cacbcd" @click="onChangeGroupName">
                  {{$t('group.change_group_name')}}
                </b-button>
                <b-button class="flex_1 center bottom_btn_text btn_lg" style="background-color: #0840ba" @click="onAddGroup">
                  {{$t('group.add_group')}}
                </b-button>
              </div>
            </div>
          </div>
          <div class="align-vertical" v-if="showGroupMemberMng">
            <div class="align-horizontal" style="height: 50px; justify-content: space-around; border-bottom: solid 1px #cacbcd">
              <span class="bottom_btn_text flex_1" style="color: #457fff; text-align: center;">{{$t('group.name')}}</span>
              <span class="bottom_btn_text flex_1" style="color: #457fff; text-align: center;">{{$t('group.member_number')}}</span>
            </div>
            <div class="align-vertical" style="overflow-y: auto">
              <div class="align-horizontal center" style="height: 50px; justify-content: space-around"
                   v-for="(item, index) in groupMemberList" :key="`group_member-${index.toString()}`">
                <span class="bottom_btn_text flex_1" style="color: black; text-align: center;">{{item.f_user_name}}</span>
                <span class="bottom_btn_text flex_1" style="color: black; text-align: center;">{{u.formatPhoneNumber(item.f_phone)}}</span>
              </div>
            </div>
            <div class="align-horizontal">
              <b-button class="flex_1 center bottom_btn_text btn_lg" style="background-color: #cf0000" @click="onLeaveGroup">
                {{$t('group.leave_group')}}
              </b-button>
              <b-button class="flex_1 center bottom_btn_text btn_lg" style="background-color: #cacbcd" @click="onDeleteGroupMember">
                {{$t('group.delete_group_member')}}
              </b-button>
              <b-button class="flex_1 center bottom_btn_text btn_lg" style="background-color: #0840ba" @click="onAddGroupMember">
                {{$t('group.add_group_member')}}
              </b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="container scroll pt-2" style="height: 100vh;overflow-y: auto" @scroll="onScroll" ref="wrap">
        <SiteItem v-for="(item, index) in saleList"
                  :key="`sale-${index.toString()}`"
                  :item="item"
                  :isAdmin="true"
                  :show-btn="activeTab != TAB.TRANSFER"
                  :isTransfer="activeTab == TAB.TRANSFER"
                  @onCell="() => onCell(item)"
                  @onLike="status => onLike(item, status)"
                  @remove="onRemove"
                  @onToggleHide="status => onToggleHide(item, status)"
                  @onToggleShareRelease="groupIdx => onToggleShareRelease(item, groupIdx)"
                  @onUpdate="_data => onModify(_data)"
                  @refresh="onRefresh"
        />
      </div>
    </div>
    <PromptConfirmPopup ref="prompt" />
    <ConfirmPopupGroup ref="confirm" />
    <Navbar />
  </div>
</template>

<script>
import Utils from "../../../../config/utils";
import SiteItem from "../../../controls/SiteItem";
import Navbar from "../../../controls/navbar"
import PromptConfirmPopup from "../../../controls/popup/PromptConfirmPopup";
import ConfirmPopupGroup from "../../../controls/popup/ConfirmPopupGroup";
import SiteDetail from "../interest/SiteDetail";

const util = require('util');
export const TAB = {
  ALL: '',
  NEW: 'O',
  GENERAL: 'G',
  GROUP: 'GP',
  TRANSFER: 'T'
};
export default {
  name: "SaleList",
  components: {SiteDetail, ConfirmPopupGroup, PromptConfirmPopup, SiteItem, Navbar},
  watch: {
    activeTab: function (newVal, oldVal) {
      this.$store.commit('setTmpTabIndex', newVal);
      this.search_name = "";
      if (newVal == TAB.ALL)
        this.initList();
      else if (newVal == TAB.GROUP){
        this.showGroupList = false;
        this.showGroupMemberMng = false;
        this.goToGroupMaemul();
      }
      else
        this.initList(TAB.TRANSFER);
    }
  },
  data() {
    return {
      self: this,
      u: Utils,
      ut: util,
      TAB: TAB,
      activeTab: this.$store.getters.getTmpTabIndex ? this.$store.getters.getTmpTabIndex : TAB.ALL,
      // activeTab: TAB.ALL,
      saleList: [],
      pageNum: 1,
      loadingEnd: false,
      showTransferPopup: false,
      selectedItem: null,

      showGroupList: false,
      showGroupMemberMng: false,
      selectedGroup: null,
      myGroupList: [],
      groupMemberList: [],
      search_name: '',
    }
  },
  computed: {

  },
  methods:{
    onAddGroupMember() {
      if (this.selectedGroup){
        this.$refs.prompt.show(this.$t('group.add_group_member'),
          this.$t('group.add_group_member_placeholder'), '', (phone_number) =>{
            Utils.requestGet(this.$c.API.Group.addMemberToGroup, {
              group_idx: this.selectedGroup.f_idx,
              phone_number: phone_number.replaceAll('-', ''),
            }).then(result => {
              if(result.code == this.$c.API_RES_CODE.SUCCESS)
              {
                Utils.setState(this,{groupMemberList: result.data.list});
              } else
                Utils.toast(this, result.msg);
            });
          }, false, '', true);
      } else
        Utils.toast(this, this.$t('group.select_group'));
    },

    onDeleteGroupMember() {
      if (this.selectedGroup){
        this.$refs.prompt.show(this.$t('group.delete_group_member'),
          this.$t('group.delete_group_member_placeholder'), '', (phone_number) =>{
            if (phone_number.replaceAll('-', '') == this.myinfo.phone) {
              this._leaveGroup();
            } else {
              Utils.requestGet(this.$c.API.Group.deleteMemberFromGroup, {
                group_idx: this.selectedGroup.f_idx,
                phone_number: phone_number.replaceAll('-', ''),
              }).then(result => {
                if(result.code == this.$c.API_RES_CODE.SUCCESS)
                {
                  Utils.setState(this,{groupMemberList: result.data.list});
                } else
                  Utils.toast(this,result.code == this.$c.API_RES_CODE.ERR_PARAM ? this.$t('group.no_group') :result.msg);
              });
            }
          }, false, '', true);
      } else
        Utils.toast(this, this.$t('group.select_group'));
    },

    _leaveGroup() {
      Utils.requestGet(this.$c.API.Group.leaveGroup, {group_idx: this.selectedGroup.f_idx}).then(result => {
        if(result.code == this.$c.API_RES_CODE.SUCCESS){
          Utils.setState(this,{
            myGroupList: result.data.groupList,
            selectedGroup: result.data.recent,
            groupMemberList: [],
          }, () => this.getSitesOfGroup());
        } else
          Utils.toast(this,result.msg);
      });
    },

    onLeaveGroup() {
      if (this.selectedGroup){
        this.$refs.confirm.show(this.selectedGroup ? this.selectedGroup.f_name : '',
          this.$t('group.leave_group_question'), 'LG', () =>{
            this._leaveGroup();
          })
      } else
        Utils.toast(this, this.$t('group.no_group_involved'));
    },

    onChangeGroupName() {
      if (this.selectedGroup){
        this.$refs.prompt.show(this.$t('group.change_group_name'), this.$t('group.change_group_name_placeholder'), this.$t('group.change_group_name_desc'),
          (group_name)=>{
            Utils.requestGet(this.$c.API.Group.changeGroupName, {group_name: group_name, group_idx: this.selectedGroup.f_idx}).then(result => {
              if(result.code == this.$c.API_RES_CODE.SUCCESS){
                Utils.setState(this,{
                  myGroupList: result.data,
                  selectedGroup: {f_idx: this.selectedGroup.f_idx, f_name: group_name},
                });
              } else
                Utils.toast(this, result.msg);
            })
          }, true, this.selectedGroup ? this.selectedGroup.f_name : '')
      } else
        Utils.toast(this, this.$t('group.no_group_involved'));
    },

    onShowGroup() {
      if (!this.showGroupList) {
        Utils.requestGet(this.$c.API.Group.getMyGroupList, []).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            Utils.setState(this,{
              showGroupList: true,
              showGroupMemberMng: false,
              myGroupList: result.data,
            });
          } else
            Utils.toast(this, result.msg);
        });
      } else
        Utils.setState(this, {
          showGroupList: false,
          showGroupMemberMng: false,
        });
    },

    onShowGroupMemberMng() {
      if (this.selectedGroup) {
        Utils.requestGet(this.$c.API.Group.getMembersOfGroup, {group_idx: this.selectedGroup.f_idx}).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS)
            Utils.setState(this,{
              showGroupList: false,
              showGroupMemberMng: !this.showGroupMemberMng,
              groupMemberList: result.data.list,
            });
          else
            Utils.toast(this,result.msg);
        });
      } else {
        Utils.toast(this, this.$t('group.select_group'));
      }
    },

    onAddGroup() {
      this.$refs.prompt.show(this.$t('group.create_group_title'), this.$t('group.create_group_placeholder'), this.$t('group.create_group_desc'), (group_name) => {
        Utils.requestGet(this.$c.API.Group.addGroup, {group_name: group_name}).then(result => {
          if(result.code == this.$c.API_RES_CODE.SUCCESS){
            Utils.setState(this,{
              selectedGroup: {f_idx: result.data.new_group_idx, f_name: group_name},
              myGroupList: result.data.groupList,
              saleList: [],
            });
          } else {
            Utils.toast(this, result.msg);
          }
        });
      });
    },

    onLike(item, status) {
      Utils.setState(this,{
        saleList: this.saleList.map(it => {
          if (it.f_idx == item.f_idx) {
            it.f_like = status;
          }
          return it;
        }),
      });
    },

    onCell(item) {
      if (this.activeTab != TAB.TRANSFER)
      {
        Utils.requestGet(
          this.$c.API.Site.getSiteDetail,
          {
            site_idx: item.f_idx,
          },
        ).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            NavigationService.navigate('SiteDetail', {
              site: result.data,
            });
            if (result.data.isHidden) {
              Utils.toast(this, result.data.hiddenMsg)
            }
          } else {
            Utils.toast(this, result.msg);
          }
        });
      }
    },

    onRemove(idx) {
      Utils.setState(this,{
        saleList: this.saleList.filter(it => {
          return it.f_idx != idx;
        }),
      });
    },

    onModify(data) {
      Utils.requestGet(
        this.$c.API.Site.getSiteDetail,
        {
          site_idx: data.common.f_idx,
        }).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {

          if (result.data.common.f_site_type == 'G') {
            this.$router.push({name: 'RegSite1', params: {
              type: 'General',
              "common": result.data.common,
              "contact_list": result.data.contact_list,
              "room_list": result.data.room_list
            }});
          } else {
            this.$router.push({name: 'RegNewOpenSite1', params: {
              type: 'New',
              "common": result.data.common,
              "ho_list": result.data.ho_list,
              "dong_list": result.data.dong_list,
              "contact_list": result.data.contact_list,
              "room_list": result.data.room_list
            }});
          }
        }
      });
    },

    onSaleModify (id) {
      this.initList(this.activeTab);
      // Utils.requestGet(
      //   this.$c.API.Site.getSiteDetail,
      //   {
      //     site_idx: id,
      //   }).then(result => {
      //   if (result.code == this.$c.API_RES_CODE.SUCCESS) {
      //     Utils.setState(state => ({
      //       saleList: state.saleList.map(it => {
      //         return it.f_idx == id ? result.data.common : it;
      //       })
      //     }));
      //   }
      // });
    },

    onToggleHide(item, status) {
      Utils.setState(this,{
        saleList: this.saleList.map(it => {
          if (it.f_idx == item.f_idx) {
            it.f_hidden = status;
          }
          return it;
        }),
      });
    },

    onToggleShareRelease(item, group_idx) {
      let tmpState = this.saleList.map(it => {
        if (it.f_idx == item.f_idx) {
          it.f_group_idx = group_idx;
        }
        return it;
      });
      if (this.activeTab === TAB.GROUP && group_idx == null){
        tmpState = tmpState.filter(it => {
          return it.f_idx != item.f_idx;
        });
      }
      this.saleList = tmpState;
    },

    initList(tab=null) {
      Utils.setState(this,{
        activeTab: tab != null ? tab : this.activeTab,
        pageNum: 1,
        loadingEnd: false,
        saleList: [],
      }, () => this.getList());
    },
    onRefresh() {
      if (this.activeTab === TAB.GROUP)
        this.goToGroupMaemul()
      else
        this.initList();
    },

    updateAll() {
      let group_idx = ""
      if (this.activeTab === TAB.GROUP)
        group_idx = this.selectedGroup.f_idx;
      Utils.requestGet(this.$c.API.Site.updateGeneralSite,
        {
          group_idx: group_idx,
        }).then(result => {
        if(result.code == this.$c.API_RES_CODE.SUCCESS){
          this.onRefresh();
        }
        else {
          Utils.toast(this, result.msg);
        }
      });
    },

    goToGroupMaemul () {
      Utils.setState(this,{saleList: [], activeTab: TAB.GROUP}, () => {
        Utils.requestGet(this.$c.API.Group.getRecentVisitGroup, {}).then(result => {
          if(result.code == this.$c.API_RES_CODE.SUCCESS) {
            Utils.setState(this,{selectedGroup: result.data.recentGroup.f_name ? result.data.recentGroup : null}, () => {
              this.getSitesOfGroup();
            });
          }
        });
      });
    },

    getSitesOfGroup() {
      if (this.selectedGroup) {
        Utils.requestGet(this.$c.API.Site.getSiteOfGroup,
          {
            group_idx: this.selectedGroup.f_idx,
            search_key: this.search_name,
          }).then(result => {
          if(result.code == this.$c.API_RES_CODE.SUCCESS)
            this.saleList = result.data.list;
          else {
            Utils.toast(this, result.msg);
          }
        });
      } else
        this.saleList = [];
    },

    onScroll(){
      if (this.saleList.length === 0)
        return;
      else {
        let wrap = this.$refs.wrap;
        if(wrap.scrollHeight - Math.ceil(wrap.scrollTop) <= wrap.clientHeight){ //end of scroll
          if (!this.loadingEnd && !this.$store.getters.isLoading){
            this.getList();
          }
        }
      }

    },

    onSearch() {
      this.pageNum = 1;
      this.loadingEnd = false;
      this.saleList = [];
      if (this.activeTab == TAB.GROUP)
        this.getSitesOfGroup();
      else
        this.getList();
    },

    getList () {
      let {activeTab, pageNum, loadingEnd} = this;

      // if (this.$store.getters.isLoading) {
      //   return;
      // }
      if (loadingEnd) {
        return;
      }

      if (activeTab != TAB.GROUP)
      {
        Utils.requestGet(
          this.$c.API.Site.getMySiteList,
          {
            site_type: activeTab,
            page_num: pageNum,
            search_key: this.search_name,
          },
        ).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            Utils.setState(this,{
              loadingEnd: result.data.count > result.data.list.length,
              // loadingEnd: true,
              pageNum: ++this.pageNum,
              saleList: this.saleList.concat(result.data.list),
            });
          } else {
            Utils.toast(this, result.msg);
          }
        });
      }
    },
  },
  inject: ['eventBus'],
  mounted() {
    if (this.activeTab == TAB.GROUP)
      this.goToGroupMaemul();
    else
      this.initList(this.activeTab);
    this.eventBus.$on('sale_modify', this.onSaleModify);
    this.eventBus.$on('gotoGroup', this.goToGroupMaemul);
  }
}
</script>

<style scoped lang="scss">
  @import "../../../../assets/css/vars";
  .btn_lg{
    height: 50px;
    border-radius: 0!important;
  }
  .img_link {
    position: absolute;
    top: calc(50% - 5px);
    left: calc(50% - 12px);
    z-index: 1;
  }
  .header {height: 54px; align-items: center; justify-content: center;width: 480px;}
  .page_title {color: black; font-size: $fs_17}
  .tab_bar {border-bottom:solid 1px #eae9e9;  height: 60px;width: 480px;padding-left: 15px;}
  .tab {flex: 1; border-bottom: solid 3px transparent;}
  .tab_active {border-bottom-color: $primary}
  .tab_text {color: black; font-size: $fs_15}
  .tab_active_text {color: $primary};
  .bottom_btn_text {color: $white; font-size: $fs_18; font-family: $korean_gd_15_r}
  .tab-item {
    color:black;
    font-size: $fs_18;
    font-family: $korean_gd_15_r;
  }
  .md_tab_header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background-color: white
  }
  .body {
    padding-top: 115px;
    padding-bottom: $main_tab_height;
  }
  .nav-item {
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/contents/main/sale/SaleList.vue